export default {"src":"/_next/static/media/like.0175dbf9.svg","height":51,"width":50,"blurWidth":0,"blurHeight":0};